import { RouteDataInterface } from '../../interfaces/route-data/route-data-interface';
import { LabelConfigModel } from '@fh-client-interaction-frontends/fh-label';
import { FhTableOptionsModel } from '@fh-client-interaction-frontends/fh-table';
import { FhSideBarServiceConfigModel } from '@fh-client-interaction-frontends/fh-side-bar';
import { UiListModel } from '@fh-client-interaction-frontends/fh-providers';
import { ButtonsOptionsModel } from '@fh-client-interaction-frontends/fh-sales-portal-service';

export class RouteDataModel implements RouteDataInterface {
  title: string = '';
  description: string = '';
  detailFields: LabelConfigModel[] = new Array<LabelConfigModel>();
  detailFieldsSplit?: Array<any> = new Array<any>();
  feature: string = '';
  tables: FhTableOptionsModel[] = new Array<FhTableOptionsModel>();
  extraText?: string = '';
  uiList: UiListModel[] = new Array<UiListModel>();
  formName: string = '';
  fhSideBarConfigs: FhSideBarServiceConfigModel = new FhSideBarServiceConfigModel();
  featureApiKey: string = '';
  buttons?: ButtonsOptionsModel = new ButtonsOptionsModel();

  constructor(init?: Partial<RouteDataModel>) {
    Object.assign(this, init);
  }
}
